<template>
  <MDBBtn :class="customClass" :ripple="false" v-bind="$attrs">
    <span :class="getSize">
      <slot>{{ props.text }}</slot>
    </span>
  </MDBBtn>
</template>

<script>
import { computed } from 'vue';
import { MDBBtn } from 'mdb-vue-ui-kit';
export default {
  components: {
    MDBBtn,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    customOutline: {
      type: String,
      required: false,
      validator(value) {
        return ['default', 'disabled', 'danger'].includes(value);
      },
    },
    size: {
      type: String,
      validator(value) {
        return ['sm', 'md', 'lg'].includes(value);
      },
    },
  },
  setup(props) {
    const customClass = computed(() => {
      return [
        'spa-button',
        props.customOutline && `btn-outline-${props.customOutline}`,
      ];
    });

    const getSize = computed(() => {
      return `spa-button--${props.size}`;
    });
    return {
      customClass,
      getSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.spa-button {
  height: min-content;
  padding: 4px 8px;
  font-weight: 500;
  font-size: 1rem;
  background-color: $green-300;
  color: $neutral-0;
  text-transform: unset;
  box-shadow: none;
  border: 1px solid transparent;
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;

  &:disabled {
    background-color: $neutral-40;
  }

  &:hover {
    background-color: $green-200;
  }

  &:active {
    background-color: $green-400;
  }

  &.btn-light {
    color: $neutral-400;
    background-color: $neutral-0;
  }

  &.btn-outline-default {
    border-width: 1px;
    border-color: $green-300;
    background-color: $neutral-0;
    color: $green-300;

    &:hover {
      background-color: $green-300;
      color: $neutral-0;
    }
  }

  &.btn-outline-disabled {
    border-width: 1px;
    border-color: $neutral-40;
    background-color: $neutral-0;
    color: $neutral-40;
    &:hover {
      cursor: not-allowed;
    }
  }

  &.btn-outline-primary {
    background-color: $neutral-10;
    color: $neutral-800;
    padding: 10px;
    &:hover {
      background-color: $neutral-400;
      color: $neutral-0;
    }
  }

  &.btn-outline-danger {
    border-width: 1px;
    border-color: $red-300;
    background-color: $neutral-0;
    color: $red-300 !important;
  }

  &.btn-success {
    background-color: $green-300;
    color: $neutral-0;
    &:disabled {
      background-color: $neutral-40;
    }
  }

  &.btn-tertiary {
    background-color: $neutral-0;
    color: $green-300;
    &:disabled {
      color: $neutral-40;
    }
  }

  &.btn-warning {
    background-color: $orange-300;
    color: $neutral-0;
  }

  &.btn-danger {
    background-color: $red-300;
    color: $neutral-0;
    &:hover {
      background-color: $red-200;
    }
    &:active {
      background-color: $red-400;
    }
    &:disabled {
      background-color: $neutral-40;
    }
  }

  &.btn-primary {
    background-color: $neutral-0;
    color: $green-300;
    padding: 4px;

    &:hover {
      background-color: $green-50;
    }

    &:active {
      background-color: $green-75;
    }

    &:disabled {
      color: $neutral-40;
    }
  }

  &--sm {
    padding: 2px 4px;
  }

  &--md {
    padding: 4px;
  }

  &--lg {
    padding: 6px;
  }
}
</style>
